import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import Home from "./components/Home.js";
import InfoHeader from "./InfoHeader.js";
import Footer from "./Footer.js";
import Conferences from "./components/Conferences.js";
import Conference from "./components/Conference.js";
import BoardOfDirectors from "./components/BoardOfDirectors.js";
import ProgramLines from "./components/ProgramLines.js";
import Regulation from "./components/Regulation.js";
import InMemoryOf from "./components/InMemoryOf.js";
import Contact from "./components/Contact.js";
import History from "./components/History.js";
import Sponsor from "./components/Sponsor.js";
import CallsAwards from "./components/CallsAwards.js";
import AnnouncementsDsm from "./components/AnnouncementsDsm.js";
import DsmSupportedEvents from "./components/DsmSupportedEvents.js";
import SchoolCourses from "./components/SchoolCourses.js";
import VirtualResource from "./components/VirtualResource.js";
import DsmArchive from "./components/DsmArchive.js";
import RegisterForDsm from "./components/RegisterForDsm.js";
import DsmDiary from "./components/DsmDiary.js";
import YouthDesk from "./components/YouthDesk.js";
import TrainingSchool from "./components/TrainingSchool.js";
import TrainingSchools from "./components/TrainingSchools.js";
import School from "./components/School.js";
import Company from "./components/Company.js";
import Feedback from "./components/Feedback.js";
import InMemoryOfPeople from "./components/InMemoryOfPeople.js";

import CatchAllHandler from "./components/CatchAllHandler.js";
import LanguageSelector from "./LanguageSelector.js";

const App = () => {
  return (
    <div className="div-principale">
      <BrowserRouter>
        <header className="app-header">
    
          <InfoHeader />
        </header>

        <div className="app-container">
          <Routes>
            <Route path="/home" element={<Home />} />
            <Route path="/" element={<Home />} />
            <Route path="/board_of_directors" element={<BoardOfDirectors />} />
            <Route path="/program_lines" element={<ProgramLines />} />
            <Route path="/regulation" element={<Regulation />} />
            <Route path="/history" element={<History />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/feedback" element={<Feedback />} />
            <Route path="/calls_and_awards" element={<CallsAwards />} />
            <Route path="/announcements_dsm" element={<AnnouncementsDsm />} />
            <Route
              path="/dsm_supported_events"
              element={<DsmSupportedEvents />}
            />
            <Route path="/youth_desk" element={<YouthDesk />} />
            <Route path="/dsm_diary" element={<DsmDiary />} />
            <Route path="/register_for_dsm" element={<RegisterForDsm />} />
            <Route path="/dsm_archive" element={<DsmArchive />} />
            <Route path="/virtual_resources" element={<VirtualResource />} />
            <Route path="/sponsor" element={<Sponsor />} />
            <Route path="/company" element={<Company />} />

            <Route path="/in_memory_of_people" element={<InMemoryOfPeople />} />
            <Route path="/conferences_workshop" element={<Conferences />} />
            <Route path="/training_schools" element={<TrainingSchools />} />
            <Route path="/schools_and_courses" element={<SchoolCourses />} />

            {/*<Route path="/training_school" element={<TrainingSchool />} />*/}
            {/*<Route path="/in_memory_of" element={<InMemoryOf />} />*/}
            {/*<Route path="/conference" element={<Conference />} />*/}
            {/*Route path="/school" element={<School />} />*
            <Route path="*" element={<Navigate to="/home" />} />
            */}

            <Route path="/*" element={<CatchAllHandler />} />
          </Routes>
        </div>

        <footer className="app-footer">
          <Footer />
        </footer>
      </BrowserRouter>
    </div>
  );
};

export default App;

{
  /*
  import CatchAllHandler from "./components/CatchAllHandler.js";
            <Route path="/*" element={<CatchAllHandler />} />
            // la gestione per bypassare il singler page route di Aruba
            QUESTO E' DA VERIFICARE IN SEGUITO 
            */
}
